import {
  BLANK_CUSTOMER_LOOKUP_CONFIG,
  BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG,
  BLANK_SELLER_INFORMATION_LOOKUP_CONFIG,
  IDataCreateState,
  TEAM_LEVEL_DATA_REPORT_KEY_NAME,
} from "./definitions";
import { useAppSelector } from "app/store";

export const useGetDataLookupState = (
  queryType: string,
  gaiaObjectId: string
) => {
  var dataLookupStateName: string;
  var blankReport;
  // switch query type to define the state name
  switch (queryType) {
    case "CUSTOMER_INFORMATION_LOOKUP":
      dataLookupStateName = "customerLookup";
      blankReport = BLANK_CUSTOMER_LOOKUP_CONFIG;
      break;
    case "CUSTOMER_INFORMATION_LOOKUP_BY_BRAAVOS":
      dataLookupStateName = "customerLookup";
      blankReport = BLANK_CUSTOMER_LOOKUP_CONFIG;
      break;
    case "BrazilMarketPlaceSellerLookup":
      dataLookupStateName = "marketplaceSellerLookup";
      blankReport = BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG;
      break;
    case "SellerInformationLookup":
      dataLookupStateName = "sellerInformationLookup";
      blankReport = BLANK_SELLER_INFORMATION_LOOKUP_CONFIG;
      break;
    default:
      dataLookupStateName = "customerLookup";
      blankReport = BLANK_CUSTOMER_LOOKUP_CONFIG;
      break;
  }

  const initialDataUsageState = useAppSelector(
    (state) => state.dataCreate[dataLookupStateName as keyof IDataCreateState]
  );
  return gaiaObjectId
    ? gaiaObjectId in initialDataUsageState
      ? initialDataUsageState[gaiaObjectId]
      : blankReport
    : initialDataUsageState[TEAM_LEVEL_DATA_REPORT_KEY_NAME];
};

export const useGetCustomerLookupState = (gaiaObjectId: string) => {
  const customerLookupState = useAppSelector(
    (state) => state.dataCreate.customerLookup
  );
  return gaiaObjectId
    ? gaiaObjectId in customerLookupState
      ? customerLookupState[gaiaObjectId]
      : BLANK_CUSTOMER_LOOKUP_CONFIG
    : customerLookupState[TEAM_LEVEL_DATA_REPORT_KEY_NAME];
};

export const useGetMarketsellerLookupState = (gaiaObjectId: string) => {
  const initialMarketplaceSellerLookupState = useAppSelector(
    (state) => state.dataCreate.marketplaceSellerLookup
  );
  return gaiaObjectId
    ? gaiaObjectId in initialMarketplaceSellerLookupState
      ? initialMarketplaceSellerLookupState[gaiaObjectId]
      : BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG
    : initialMarketplaceSellerLookupState[TEAM_LEVEL_DATA_REPORT_KEY_NAME];
};

export const useGetSellerInformationLookupState = (gaiaObjectId: string) => {
  const sellerInformationLookupState = useAppSelector(
    (state) => state.dataCreate.sellerInformationLookup
  );
  return gaiaObjectId
    ? gaiaObjectId in sellerInformationLookupState
      ? sellerInformationLookupState[gaiaObjectId]
      : BLANK_SELLER_INFORMATION_LOOKUP_CONFIG
    : sellerInformationLookupState[TEAM_LEVEL_DATA_REPORT_KEY_NAME];
};
